import { render } from "./Filters.vue?vue&type=template&id=64cc8fb8"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64cc8fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64cc8fb8', __exports__)) {
    api.reload('64cc8fb8', __exports__)
  }
  
  module.hot.accept("./Filters.vue?vue&type=template&id=64cc8fb8", () => {
    api.rerender('64cc8fb8', render)
  })

}


export default __exports__